import { AccessRequest } from '@synergetx/puppet-interview-types';
import { getItemsWhere } from './firestore-utils';

const ACCESS_REQUESTS = 'AccessRequests';

export const getAccessRequests = async (): Promise<AccessRequest[]> =>
    getItemsWhere<AccessRequest>(
        ACCESS_REQUESTS,
        'getAccessRequests',
        null,
        [{ key: 'createdAt', direction: 'desc' }],
        1000,
    );
